import React from "react";
import ZipExportButton from "./ZipExportButton";
import { Popover, Space } from "antd";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import CsvExportButton from "./CsvExportButton";

const ExportButton = () => {
  return (
    <>
      <Popover
        arrowPointAtCenter
        placement="bottomRight"
        content={
          <Space className="px-3">
            <ZipExportButton />
            <CsvExportButton />
          </Space>
        }
        overlayClassName="actioncard-popover"
        trigger="click"
      >
        <>
          <PrimaryButton buttonText={"Export"} />
        </>
      </Popover>
    </>
  );
};

export default ExportButton;
